"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_1 = require("react");
const SvgCurbsideDropoff = (props, ref) => (React.createElement("svg", { ...props, xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 24 24", className: `Icon ${props?.className || ""}`, ref: ref },
    React.createElement("path", { fill: "", fillRule: "evenodd", d: "M2 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2v6.5h.5A1.5 1.5 0 0 1 8 18v1h1.619v-1.008a1.5 1.5 0 0 1-.952-1.397v-1.762a1.5 1.5 0 0 1 1.137-1.456l.778-2.538A2.6 2.6 0 0 1 13.068 9h4.602a2.6 2.6 0 0 1 2.504 1.9l.693 2.479A1.5 1.5 0 0 1 22 14.833v1.762a1.5 1.5 0 0 1-.952 1.397v1.01A1 1 0 0 1 21 21H7.5A1.5 1.5 0 0 1 6 19.5v-1H3a1 1 0 1 1 0-2h1V10a2 2 0 0 1-2-2zm4 0H4v3h2zm6 14h6.667v-.905H12zm.494-7.576a.6.6 0 0 1 .574-.424h4.602a.6.6 0 0 1 .578.439l.53 1.894H11.91zm7.125 5.243a.952.952 0 1 0 0-1.905.952.952 0 0 0 0 1.905M12 15.714a.952.952 0 1 1-1.905 0 .952.952 0 0 1 1.905 0", clipRule: "evenodd" })));
const ForwardRef = (0, react_1.forwardRef)(SvgCurbsideDropoff);
exports.default = ForwardRef;
